export enum MaritalStatus {
  UNKNOWN = 'UNKNOWN',
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  SEPARATED = 'SEPARATED',
  DIVORCED = 'DIVORCED',
  WIDOWED = 'WIDOWED'
}

export enum CitizenshipStatus {
  UNKNOWN = 'UNKNOWN',
  US_CITIZEN = 'US_CITIZEN',
  PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
  NON_PERMANENT_RESIDENT = 'NON_PERMANENT_RESIDENT'
}

export enum PhoneType {
  UNKNOWN = 'UNKNOWN',
  HOME = 'HOME',
  WORK = 'WORK',
  MOBILE = 'MOBILE',
  OTHER = 'OTHER'
}

export enum HousingStatus {
  UNKNOWN = 'UNKNOWN',
  OWN = 'OWN',
  RENT = 'RENT',
  LIVING_RENT_FREE = 'LIVING_RENT_FREE',
  OTHER = 'OTHER'
}

export enum Suffix {
  UNKNOWN = 'UNKNOWN',
  JR = 'JR',
  SR = 'SR',
  I = 'I',
  II = 'II',
  III = 'III',
  IV = 'IV',
  V = 'V'
}

export enum IncomeSourceType {
  UNKNOWN = 'UNKNOWN',
  ALIMONY = 'ALIMONY',
  CHILD_SUPPORT = 'CHILD_SUPPORT',
  PENSION = 'PENSION',
  SOCIAL_SECURITY = 'SOCIAL_SECURITY',
  DISABILITY = 'DISABILITY',
  RENTAL = 'RENTAL',
  INVESTMENT = 'INVESTMENT',
  OTHER = 'OTHER',
  AUTOMOBILE_ALLOWANCE = 'AUTOMOBILE_ALLOWANCE',
  BOARDER_INCOME = 'BOARDER_INCOME',
  CAPITAL_GAINS = 'CAPITAL_GAINS',
  DEFINED_CONTRIBUTION_PLAN = 'DEFINED_CONTRIBUTION_PLAN',
  DIVIDENDS_INTEREST = 'DIVIDENDS_INTEREST',
  FOSTER_CARE = 'FOSTER_CARE',
  HOUSING_ALLOWANCE = 'HOUSING_ALLOWANCE',
  MORTGAGE_CREDIT_CERTIFICATE = 'MORTGAGE_CREDIT_CERTIFICATE',
  MORTGAGE_DIFFERENTIAL = 'MORTGAGE_DIFFERENTIAL',
  NOTES_RECEIVABLE_INSTALLMENT = 'NOTES_RECEIVABLE_INSTALLMENT',
  PUBLIC_ASSISTANCE = 'PUBLIC_ASSISTANCE',
  ROYALTIES = 'ROYALTIES',
  SEPARATE_MAINTENANCE = 'SEPARATE_MAINTENANCE',
  TRUST = 'TRUST',
  UNEMPLOYMENT = 'UNEMPLOYMENT',
  VA_BENEFITS_NON_EDUCATIONAL = 'VA_BENEFITS_NON_EDUCATIONAL',
  JOB_RELATED = 'JOB_RELATED',
  SEPARATE_MAINTENANCE_EXPENSE = 'SEPARATE_MAINTENANCE_EXPENSE',
}

export enum AccountType {
  UNKNOWN = 'UNKNOWN',
  AUTO = 'AUTO',
  BONDS = 'BONDS',
  BRIDGE_LOAN = 'BRIDGE_LOAN',
  BUSINESS = 'BUSINESS',
  CERTIFICATE_OF_DEPOSIT = 'CERTIFICATE_OF_DEPOSIT',
  CHECKING = 'CHECKING',
  EARNEST_MONEY = 'EARNEST_MONEY',
  EMPLOYER_ASSISTANCE = 'EMPLOYER_ASSISTANCE',
  GIFT_FUNDS = 'GIFT_FUNDS',
  GIFT_OF_EQUITY = 'GIFT_OF_EQUITY',
  GRANT = 'GRANT',
  INDIVIDUAL_DEVELOPMENT_ACCOUNT = 'INDIVIDUAL_DEVELOPMENT_ACCOUNT',
  LIFE_INSURANCE = 'LIFE_INSURANCE',
  LOT_EQUITY = 'LOT_EQUITY',
  MONEY_MARKET_FUND = 'MONEY_MARKET_FUND',
  MUTUAL_FUNDS = 'MUTUAL_FUNDS',
  OTHER_LIQUID = 'OTHER_LIQUID',
  OTHER_NON_LIQUID = 'OTHER_NON_LIQUID',
  OTHER_PURCHASE_CREDIT = 'OTHER_PURCHASE_CREDIT',
  PENDING_NET_SALE_PROCEEDS = 'PENDING_NET_SALE_PROCEEDS',
  PENDING_NET_SALE_PROCEEDS_NON_REAL_ESTATE = 'PENDING_NET_SALE_PROCEEDS_NON_REAL_ESTATE',
  RELOCATION_FUNDS = 'RELOCATION_FUNDS',
  RENT_CREDIT = 'RENT_CREDIT',
  RETIREMENT = 'RETIREMENT',
  SAVINGS = 'SAVINGS',
  SECURED_BORROWED_FUNDS = 'SECURED_BORROWED_FUNDS',
  STOCK_OPTIONS = 'STOCK_OPTIONS',
  STOCKS = 'STOCKS',
  SWEAT_EQUITY = 'SWEAT_EQUITY',
  TRADE_EQUITY = 'TRADE_EQUITY',
  TRUST_FUNDS = 'TRUST_FUNDS',
  UNSECURED_BORROWED_FUNDS = 'UNSECURED_BORROWED_FUNDS'
}

export enum AssetType {
  UNKNOWN = 'UNKNOWN',
  STOCKS = 'STOCKS',
  BONDS = 'BONDS',
  MUTUAL_FUNDS = 'MUTUAL_FUNDS',
  REAL_ESTATE = 'REAL_ESTATE',
  VEHICLE = 'VEHICLE',
  CHECKING = 'CHECKING',
  OTHER = 'OTHER'
}

export enum OccupancyType {
  UNKNOWN = 'UNKNOWN',
  PRIMARY_RESIDENCE = 'PRIMARY_RESIDENCE',
  SECOND_HOME = 'SECOND_HOME',
  INVESTMENT = 'INVESTMENT'
}

export enum PropertyStatus {
  UNKNOWN = 'UNKNOWN',
  SOLD = 'SOLD',
  PENDING = 'PENDING',
  RETAINED = 'RETAINED'
}

export enum LiabilityType {
  UNKNOWN = 'UNKNOWN',
  MORTGAGE = 'MORTGAGE',
  HELOC = 'HELOC',
  CAR_LOAN = 'CAR_LOAN',
  STUDENT_LOAN = 'STUDENT_LOAN',
  CREDIT_CARD = 'CREDIT_CARD',
  OTHER = 'OTHER'
}

export enum OtherLiabilityType {
  UNKNOWN = 'UNKNOWN',
  ALIMONY = 'ALIMONY',
  CHILD_SUPPORT = 'CHILD_SUPPORT',
  JOB_RELATED = 'JOB_RELATED',
  OTHER = 'OTHER'
}

export enum State {
  AK = "AK", // Alaska
  AL = "AL", // Alabama
  AR = "AR", // Arkansas
  AZ = "AZ", // Arizona
  CA = "CA", // California
  CO = "CO", // Colorado
  CT = "CT", // Connecticut
  DE = "DE", // Delaware
  FL = "FL", // Florida
  GA = "GA", // Georgia
  HI = "HI", // Hawaii
  IA = "IA", // Iowa
  ID = "ID", // Idaho
  IL = "IL", // Illinois
  IN = "IN", // Indiana
  KS = "KS", // Kansas
  KY = "KY", // Kentucky
  LA = "LA", // Louisiana
  MA = "MA", // Massachusetts
  MD = "MD", // Maryland
  ME = "ME", // Maine
  MI = "MI", // Michigan
  MN = "MN", // Minnesota
  MO = "MO", // Missouri
  MS = "MS", // Mississippi
  MT = "MT", // Montana
  NC = "NC", // North Carolina
  ND = "ND", // North Dakota
  NE = "NE", // Nebraska
  NH = "NH", // New Hampshire
  NJ = "NJ", // New Jersey
  NM = "NM", // New Mexico
  NV = "NV", // Nevada
  NY = "NY", // New York
  OH = "OH", // Ohio
  OK = "OK", // Oklahoma
  OR = "OR", // Oregon
  PA = "PA", // Pennsylvania
  RI = "RI", // Rhode Island
  SC = "SC", // South Carolina
  SD = "SD", // South Dakota
  TN = "TN", // Tennessee
  TX = "TX", // Texas
  UT = "UT", // Utah
  VA = "VA", // Virginia
  VT = "VT", // Vermont
  WA = "WA", // Washington
  WI = "WI", // Wisconsin
  WV = "WV", // West Virginia
  WY = "WY"  // Wyoming
}

export enum MilitaryStatus {
  ACTIVE_DUTY = 'ACTIVE_DUTY',
  RETIRED = 'RETIRED',
  RESERVE = 'RESERVE'
}

export function getStateOptions() {
  return Object.entries(State).map(([label, value]) => ({
    value,
    label
  }));
}

export enum Country {
  USA = "United States",
  AFG = "Afghanistan",
  ALA = "Aland Islands",
  ALB = "Albania",
  DZA = "Algeria",
  ASM = "American Samoa",
  AND = "Andorra",
  AGO = "Angola",
  AIA = "Anguilla",
  ATA = "Antarctica",
  ATG = "Antigua and Barbuda",
  ARG = "Argentina",
  ARM = "Armenia",
  ABW = "Aruba",
  AUS = "Australia",
  AUT = "Austria",
  AZE = "Azerbaijan",
  BHS = "Bahamas",
  BHR = "Bahrain",
  BGD = "Bangladesh",
  BRB = "Barbados",
  BLR = "Belarus",
  BEL = "Belgium",
  BLZ = "Belize",
  BEN = "Benin",
  BMU = "Bermuda",
  BTN = "Bhutan",
  BOL = "Bolivia",
  BES = "Bonaire, Sint Eustatius and Saba",
  BIH = "Bosnia and Herzegovina",
  BWA = "Botswana",
  BVT = "Bouvet Island",
  BRA = "Brazil",
  IOT = "British Indian Ocean Territory",
  BRN = "Brunei Darussalam",
  BGR = "Bulgaria",
  BFA = "Burkina Faso",
  BDI = "Burundi",
  CPV = "Cabo Verde",
  KHM = "Cambodia",
  CMR = "Cameroon",
  CAN = "Canada",
  CYM = "Cayman Islands",
  CAF = "Central African Republic",
  TCD = "Chad",
  CHL = "Chile",
  CHN = "China",
  CXR = "Christmas Island",
  CCK = "Cocos (Keeling) Islands",
  COL = "Colombia",
  COM = "Comoros",
  COG = "Congo",
  COD = "Congo, Democratic Republic of the",
  COK = "Cook Islands",
  CRI = "Costa Rica",
  CIV = "Cote d'Ivoire",
  HRV = "Croatia",
  CUB = "Cuba",
  CUW = "Curacao",
  CYP = "Cyprus",
  CZE = "Czechia",
  DNK = "Denmark",
  DJI = "Djibouti",
  DMA = "Dominica",
  DOM = "Dominican Republic",
  ECU = "Ecuador",
  EGY = "Egypt",
  SLV = "El Salvador",
  GNQ = "Equatorial Guinea",
  ERI = "Eritrea",
  EST = "Estonia",
  SWZ = "Eswatini",
  ETH = "Ethiopia",
  FLK = "Falkland Islands",
  FRO = "Faroe Islands",
  FJI = "Fiji",
  FIN = "Finland",
  FRA = "France",
  GUF = "French Guiana",
  PYF = "French Polynesia",
  ATF = "French Southern Territories",
  GAB = "Gabon",
  GMB = "Gambia",
  GEO = "Georgia",
  DEU = "Germany",
  GHA = "Ghana",
  GIB = "Gibraltar",
  GRC = "Greece",
  GRL = "Greenland",
  GRD = "Grenada",
  GLP = "Guadeloupe",
  GUM = "Guam",
  GTM = "Guatemala",
  GGY = "Guernsey",
  GIN = "Guinea",
  GNB = "Guinea-Bissau",
  GUY = "Guyana",
  HTI = "Haiti",
  HMD = "Heard Island and McDonald Islands",
  VAT = "Holy See",
  HND = "Honduras",
  HKG = "Hong Kong",
  HUN = "Hungary",
  ISL = "Iceland",
  IND = "India",
  IDN = "Indonesia",
  IRN = "Iran",
  IRQ = "Iraq",
  IRL = "Ireland",
  IMN = "Isle of Man",
  ISR = "Israel",
  ITA = "Italy",
  JAM = "Jamaica",
  JPN = "Japan",
  JEY = "Jersey",
  JOR = "Jordan",
  KAZ = "Kazakhstan",
  KEN = "Kenya",
  KIR = "Kiribati",
  PRK = "Korea (Democratic People's Republic of)",
  KOR = "Korea, Republic of",
  KWT = "Kuwait",
  KGZ = "Kyrgyzstan",
  LAO = "Laos",
  LVA = "Latvia",
  LBN = "Lebanon",
  LSO = "Lesotho",
  LBR = "Liberia",
  LBY = "Libya",
  LIE = "Liechtenstein",
  LTU = "Lithuania",
  LUX = "Luxembourg",
  MAC = "Macao",
  MKD = "Macedonia",
  MDG = "Madagascar",
  MWI = "Malawi",
  MYS = "Malaysia",
  MDV = "Maldives",
  MLI = "Mali",
  MLT = "Malta",
  MHL = "Marshall Islands",
  MTQ = "Martinique",
  MRT = "Mauritania",
  MUS = "Mauritius",
  MYT = "Mayotte",
  MEX = "Mexico",
  FSM = "Micronesia (Federated States of)",
  MDA = "Moldova",
  MCO = "Monaco",
  MNG = "Mongolia",
  MNE = "Montenegro",
  MSR = "Montserrat",
  MAR = "Morocco",
  MOZ = "Mozambique",
  MMR = "Myanmar",
  NAM = "Namibia",
  NRU = "Nauru",
  NPL = "Nepal",
  NLD = "Netherlands",
  NCL = "New Caledonia",
  NZL = "New Zealand",
  NIC = "Nicaragua",
  NER = "Niger",
  NGA = "Nigeria",
  NIU = "Niue",
  NFK = "Norfolk Island",
  MNP = "Northern Mariana Islands",
  NOR = "Norway",
  OMN = "Oman",
  PAK = "Pakistan",
  PLW = "Palau",
  PSE = "Palestine, State of",
  PAN = "Panama",
  PNG = "Papua New Guinea",
  PRY = "Paraguay",
  PER = "Peru",
  PHL = "Philippines",
  PCN = "Pitcairn",
  POL = "Poland",
  PRT = "Portugal",
  PRI = "Puerto Rico",
  QAT = "Qatar",
  REU = "Reunion",
  ROU = "Romania",
  RUS = "Russian Federation",
  RWA = "Rwanda",
  BLM = "Saint Barthelemy",
  SHN = "Saint Helena, Ascension and Tristan da Cunha",
  KNA = "Saint Kitts and Nevis",
  LCA = "Saint Lucia",
  MAF = "Saint Martin (French part)",
  SPM = "Saint Pierre and Miquelon",
  VCT = "Saint Vincent and the Grenadines",
  WSM = "Samoa",
  SMR = "San Marino",
  STP = "Sao Tome and Principe",
  SAU = "Saudi Arabia",
  SEN = "Senegal",
  SRB = "Serbia",
  SYC = "Seychelles",
  SLE = "Sierra Leone",
  SGP = "Singapore",
  SXM = "Sint Maarten (Dutch part)",
  SVK = "Slovakia",
  SVN = "Slovenia",
  SLB = "Solomon Islands",
  SOM = "Somalia",
  ZAF = "South Africa",
  SGS = "South Georgia and the South Sandwich Islands",
  SSD = "South Sudan",
  ESP = "Spain",
  LKA = "Sri Lanka",
  SDN = "Sudan",
  SUR = "Suriname",
  SJM = "Svalbard and Jan Mayen",
  SWE = "Sweden",
  CHE = "Switzerland",
  SYR = "Syria",
  TWN = "Taiwan",
  TJK = "Tajikistan",
  TZA = "Tanzania",
  THA = "Thailand",
  TLS = "Timor-Leste",
  TGO = "Togo",
  TKL = "Tokelau",
  TON = "Tonga",
  TTO = "Trinidad and Tobago",
  TUN = "Tunisia",
  TUR = "Turkey",
  TKM = "Turkmenistan",
  TCA = "Turks and Caicos Islands",
  TUV = "Tuvalu",
  UGA = "Uganda",
  UKR = "Ukraine",
  ARE = "United Arab Emirates",
  GBR = "United Kingdom",
  UMI = "United States Minor Outlying Islands",
  URY = "Uruguay",
  UZB = "Uzbekistan",
  VUT = "Vanuatu",
  VEN = "Venezuela",
  VNM = "Viet Nam",
  VGB = "Virgin Islands (British)",
  VIR = "Virgin Islands (U.S.)",
  WLF = "Wallis and Futuna",
  ESH = "Western Sahara",
  YEM = "Yemen",
  ZMB = "Zambia",
  ZWE = "Zimbabwe"
}

export enum MismoDebtTypeEnum {
  ALIMONY = 'ALIMONY',
  INSTALLMENT = 'INSTALLMENT',
  JOB_EXPENSE = 'JOB_EXPENSE',
  MORTGAGE = 'MORTGAGE',
  OPEN = 'OPEN',
  REVOLVING = 'REVOLVING',
  OTHER_DEBT_LIABILITY = 'OTHER_DEBT_LIABILITY',
  CHILD_SUPPORT = 'CHILD_SUPPORT',
  LEASE = 'LEASE',
  OTHER_EXPENSE_LIABILITY = 'OTHER_EXPENSE_LIABILITY',
  SEPARATE_MAINTENANCE = 'SEPARATE_MAINTENANCE',
  HELOC = 'HELOC',
}

export enum MismoLoanPurpose {
  PURCHASE = 'PURCHASE',
  REFI_RATE_TERM = 'REFI_RATE_TERM',
  REFINANCE_CASHOUT = 'REFINANCE_CASHOUT',
  CONSTRUCTION = 'CONSTRUCTION',
  CONSTRUCTION_PERM = 'CONSTRUCTION_PERM',
  OTHER = 'OTHER',
  FHA_STREAMLINE_REFI = 'FHA_STREAMLINE_REFI',
  VA_IRRRL = 'VA_IRRRL',
  HOME_EQUITY = 'HOME_EQUITY',
}

export enum MismoProjectType {
  NONE = 'NONE',
  ATTACHED = 'ATTACHED',
  CONDOMINIUM = 'CONDOMINIUM',
  COOPERATIVE = 'COOPERATIVE',
  DETACHED = 'DETACHED',
  DETACHED_CONDOMINIUM = 'DETACHED_CONDOMINIUM',
  HIGH_RISE_CONDOMINIUM = 'HIGH_RISE_CONDOMINIUM',
  MANUFACTURED_HOME_CONDOMINIUM = 'MANUFACTURED_HOME_CONDOMINIUM',
  MANUFACTURED_HOME_MULTIWIDE = 'MANUFACTURED_HOME_MULTIWIDE',
  MANUFACTURED_HOUSING = 'MANUFACTURED_HOUSING',
  MANUFACTURED_HOUSING_SINGLE_WIDE = 'MANUFACTURED_HOUSING_SINGLE_WIDE',
  MODULAR = 'MODULAR',
  PUD = 'PUD',
}

export enum ConcurrentFinancingSourceType {
  NONE = 'NONE',
  COMMUNITY_NON_PROFIT = 'COMMUNITY_NON_PROFIT',
  FEDERAL_AGENCY = 'FEDERAL_AGENCY',
  INSTITUTIONAL = 'INSTITUTIONAL',
  LENDER = 'LENDER',
  LOCAL_AGENCY = 'LOCAL_AGENCY',
  NON_PARENT_RELATIVE = 'NON_PARENT_RELATIVE',
  NON_PROFIT_INSTRUMENTALITY_OF_GOVERNMENT = 'NON_PROFIT_INSTRUMENTALITY_OF_GOVERNMENT',
  OTHER = 'OTHER',
  PARENT = 'PARENT',
  RELATIVE = 'RELATIVE',
  RELIGIOUS_NON_PROFIT = 'RELIGIOUS_NON_PROFIT',
  STATE_AGENCY = 'STATE_AGENCY',
  UNMARRIED_PARTNER = 'UNMARRIED_PARTNER',
  UNRELATED_FRIEND = 'UNRELATED_FRIEND',
  EMPLOYER = 'EMPLOYER',
  SELLER = 'SELLER',
}

export enum EmploymentIncomeType {
  BASE = 'BASE',
  OVERTIME = 'OVERTIME',
  BONUSES = 'BONUSES',
  COMMISSION = 'COMMISSION',
  CONTRACT_BASIS = 'CONTRACT_BASIS',
  MILITARY_BASE_PAY = 'MILITARY_BASE_PAY',
  MILITARY_CLOTHES_ALLOWANCE = 'MILITARY_CLOTHES_ALLOWANCE',
  MILITARY_COMBAT_PAY = 'MILITARY_COMBAT_PAY',
  MILITARY_FLIGHT_PAY = 'MILITARY_FLIGHT_PAY',
  MILITARY_HAZARD_PAY = 'MILITARY_HAZARD_PAY',
  MILITARY_OVERSEAS_PAY = 'MILITARY_OVERSEAS_PAY',
  MILITARY_PROP_PAY = 'MILITARY_PROP_PAY',
  MILITARY_QUARTERS_ALLOWANCE = 'MILITARY_QUARTERS_ALLOWANCE',
  MILITARY_RATIONS_ALLOWANCE = 'MILITARY_RATIONS_ALLOWANCE',
  MILITARY_VARIABLE_HOUSING_ALLOWANCE = 'MILITARY_VARIABLE_HOUSING_ALLOWANCE',
  OTHER = 'OTHER',
}

export enum OwnershipShareOptions {
  NONE = 'NONE',
  LESS_THAN_25 = 'LESS_THAN_25',
  MORE_THAN_25 = 'MORE_THAN_25',
}

export function getCountryOptions() {
  return Object.entries(Country).map(([value, label]) => ({ value, label }));
}

export interface Phone {
  type?: PhoneType;
  number?: string;
  extension?: string;
}

export interface AddressInfo {
  street?: string;
  unit?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  yearsAtAddress?: number;
  monthsAtAddress?: number;
  housingStatus?: HousingStatus;
  monthlyRentMortgage?: string;
  startDate?: string;
  endDate?: string;
}

export interface MailingAddressInfo {
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  isPresentAddress?: string;
}

export interface AlternateName {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
}

export interface Dependent {
  age?: string;
}

export interface BorrowerDocument {
  _id?: string;
  type?: 'PRIMARY' | 'CO_BORROWER';
  isNew?: boolean;
  personalInfo?: {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffix?: string;
    dateOfBirth?: Date;
    age?: string;
    ssn?: string;
    maritalStatus?: MaritalStatus;
    citizenship?: CitizenshipStatus;
    militaryService?: boolean,
    isActiveDuty?: boolean,
    isRetired?: boolean,
    isReserve?: boolean,
    serviceExpiration?: boolean,
    isSurvivingSpouse?: boolean,
    hasPositiveRentalHistory?: boolean;
    hasForeignAddresses?: boolean;
  };
  contact?: {
    email?: string;
    phones?: Phone[];
  };
  currentAddress?: AddressInfo;
  mailingAddress?: MailingAddressInfo;
  previousAddresses?: AddressInfo[];
  alternateNames?: AlternateName[];
  dependents?: Dependent[];
  loanApplicationId?: string;
  employmentInfoId?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export type PersonalInfo = {
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  dateOfBirth: string;
  ssn: string;
  maritalStatus: MaritalStatus | string;
  citizenship: CitizenshipStatus | string;
  militaryService: string;
  isActiveDuty: string;
  isRetired: string;
  isReserve: string;
  serviceExpiration?: string;
  isSurvivingSpouse?: string;
  hasPositiveRentalHistory?: boolean;
  hasForeignAddresses?: boolean;
};

export interface BorrowerFinancialData {
  _id: string;
  borrowerId: string;
  loanApplicationId: string;
  personalInfo: PersonalInfo;
  financial: {
    _id: string;
    loanApplicationId: string;
    borrowerId: string;
    assets: Array<{
      accountType?: AccountType;
      financialInstitution?: string;
      accountNumber?: string;
      accountBalance?: number;
      otherTypeDesc?: string;
      isCreditedAtClosing?: boolean;
      isDeposited?: boolean;
      assetStatusType?: string;
      departmentName?: string;
      streetAddress?: string;
      city?: string;
      state?: string;
      zip?: string;
      phone?: string;
      description?: string;
      value?: number;
      giftSource?: string;
      calculationMethod?: string;
    }>;
    otherAssets: Array<{
      type?: AssetType;
      marketValue?: number;
    }>;
    realEstate: Array<{
      address: {
        street?: string;
        unit?: string;
        city?: string;
        state?: string;
        zip?: string;
        country?: string;
      };
      intendedOccupancy?: OccupancyType;
      propertyValue?: number;
      monthlyInsurance?: number;
      rentalIncome?: number;
      netIncome?: number;
      status?: PropertyStatus;
    }>;
    liabilities: Array<{
      accountType?: LiabilityType;
      otherTypeDesc?: string;
      companyName?: string;
      accountNumber?: string;
      unpaidBalance?: number;
      monthlyPayment?: number;
      paidBeforeClosing?: boolean;
      // NEW
      owners?: Array<{ consumerId: string }>;
      companyAddress?: string;
      companyPhone?: string;
      companyCity?: string;
      companyState?: string;
      companyZip?: string;
      companyFax?: string;
      propertyAddress?: string;
      desc?: string;
      mortgageType?: string;
      linkedReoId?: string;
      linkedAssetId?: string;
      accountName?: string;
      accountNum?: string;
      maximumBalance?: string;
      bal?: string;
      pmt?: string;
      remainMon?: string;
      rate?: string;
      originalTermAsString?: string;
      dueInMonAsString?: string;
      willBePdOff?: boolean;
      payoffAmt?: string;
      payoffAmtLocked?: boolean;
      payoffTiming?: string;
      payoffTimingLockedData?: boolean;
      payoffAmtData?: string;
      late30AsString?: string;
      late60AsString?: string;
      late90PlusAsString?: string;
      usedInRatio?: boolean;
      isPiggyBack?: boolean;
      excludeFromUw?: boolean;
      isHeldByLenderOfNewLoan?: boolean;
      includeInReposession?: boolean;
      includeInBk?: boolean;
      includeInFc?: boolean;
    }>;
    otherLiabilities: Array<{
      type?: OtherLiabilityType;
      monthlyPayment?: number;
    }>;
    createdAt?: Date;
    updatedAt?: Date;
  }
}


export interface LoanApplication {
  _id: string;
  borrowers: BorrowerFormData[];
  employment: BorrowerEmploymentData;
  financialInfo: BorrowerFinancialData;
  // loanProperty: BorrowerLoanPropertyData[];
  // declaration: BorrowerDeclarationData[];
  // demographic: BorrowerDemographicData[];
  // originator: BorrowerOriginatorData[];
}

export interface HousingExpenses {
  principalAndInterest: string; // Mortgage (P & I)
  otherFinancing: string; // Other Financing (P & I)
  hazardInsurance: string; // Hazard Insurance (HOI)
  propertyTax: string; // Property Tax
  mortgageInsurance: string; // Mortgage Insurance (PMI)
  hoaDues: string; // HOA Dues
  otherExpenses: string; // Other Taxes and Expenses
  pitiTotal: string; // PITI (Auto Calculated)
}

export const defaultValueBorrowerFormData: BorrowerFormData = {
  _id: '',
  type: 'CO_BORROWER',
  isNew: true,
  personalInfo: {
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    title: '',
    preferredName: '',
    dateOfBirth: '',
    age: '',
    ssn: '',
    maritalStatus: '',
    citizenship: '',
    militaryService: '',
    isActiveDuty: '',
    isRetired: '',
    isReserve: '',
    serviceExpiration: '',
    isSurvivingSpouse: '',
    hasPositiveRentalHistory: '',
    hasForeignAddresses: '',
  },
  contact: {
    email: '',
    phones: [],
  },
  employment: {
    _id: '',
    borrowerId: '',
    loanApplicationId: '',
    personalInfo: {
      firstName: '',
      middleName: '',
      lastName: '',
      suffix: '',
      dateOfBirth: '',
      ssn: '',
      maritalStatus: '',
      citizenship: '',
      militaryService: '',
      isActiveDuty: '',
      isRetired: '',
      isReserve: '',
      serviceExpiration: '',
    },
    employment: {
      _id: '',
      borrowerId: '',
      loanApplicationId: '',
      currentEmployments: [{
        _id: '',
        employerName: '',
        position: '',
        startDate: new Date(),
        endDate: new Date(),
        years: '',
        months: '',
        professionStartDate: new Date(),
        professionEndDate: new Date(),
        professionYears: '',
        professionMonths: '',
        phone: '',
        fax: '',
        employerDbaName: [],
        isCurrentlyEmployed: false,
        isEmployedByFamilyMember: false,
        isBusinessOwner: false,
        employmentStatus: '',
        monthlyIncome: [{
          incomeType: EmploymentIncomeType.BASE,
          monthlyAmount: ''
        }],
        address: {
          street: '',
          unit: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        },
      }],
      previousEmployments: [{
        _id: '',
        employerName: '',
        position: '',
        startDate: new Date(),
        endDate: new Date(),
        years: '',
        months: '',
        professionStartDate: new Date(),
        professionEndDate: new Date(),
        professionYears: '',
        professionMonths: '',
        phone: '',
        fax: '',
        employerDbaName: [],
        isCurrentlyEmployed: false,
        isEmployedByFamilyMember: false,
        isBusinessOwner: false,
        employmentStatus: '',
        monthlyIncome: [{
          incomeType: EmploymentIncomeType.BASE,
          monthlyAmount: ''
        }],
        address: {
          street: '',
          unit: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        },
      }],
      otherIncomes: [{
        _id: '',
        type: IncomeSourceType.OTHER,
        monthlyAmount: '',
        description: '',
        isConsistent: false,
        isDocumented: false
      }]
    }
  },
  currentAddress: {
    street: '',
    unit: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    yearsAtAddress: 0,
    monthsAtAddress: 0,
    startDate: '',
    housingStatus: HousingStatus.RENT,
    monthlyRentMortgage: '',
  },
  mailingAddress: {
    street: '',
    city: '',
    state: '',
    zip: '',
    isPresentAddress: 'No'
  },
  previousAddresses: [],
  alternateNames: [],
  dependents: [],
  loanApplicationId: '',
  housingExpenses: {
    principalAndInterest: '',
    otherFinancing: '',
    hazardInsurance: '',
    propertyTax: '',
    mortgageInsurance: '',
    hoaDues: '',
    otherExpenses: '',
    pitiTotal: '',
  },
  createdAt: new Date(),
  updatedAt: new Date(),
  __v: 0,
  id: ''
}

export interface BorrowerFormData {
  _id?: string;
  type?: 'PRIMARY' | 'CO_BORROWER';
  isNew?: boolean;
  personalInfo: {
    firstName: string;
    middleName: string;
    lastName: string;
    suffix: string;
    title: string;
    preferredName: string;
    dateOfBirth: string;
    age: string;
    ssn: string;
    maritalStatus: MaritalStatus | string;
    citizenship: CitizenshipStatus | string;
    militaryService: string;
    isActiveDuty: string;
    isRetired: string;
    isReserve: string;
    serviceExpiration: string;
    isSurvivingSpouse: string;
    hasPositiveRentalHistory: string;
    hasForeignAddresses: string;
  };
  contact: {
    email: string;
    extension?: string;
    phones: Array<{
      type: PhoneType;
      number: string;
      extension?: string;
      _id?: string;
    }>;
  };
  employment: BorrowerEmploymentData;
  currentAddress: {
    street: string;
    unit: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    yearsAtAddress: number;
    monthsAtAddress: number;
    housingStatus: HousingStatus | string;
    startDate: string;
    monthlyRentMortgage: string;
    _id?: string;
  };
  mailingAddress: {
    street: string;
    city: string;
    state: string;
    zip: string;
    isPresentAddress: string;
  };
  previousAddresses: Array<{
    street: string;
    unit: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    yearsAtAddress: number;
    monthsAtAddress: number;
    housingStatus: HousingStatus | string;
    startDate: string;
    endDate: string;
    _id?: string;
  }>;
  alternateNames: Array<{
    firstName: string;
    middleName: string;
    lastName: string;
    suffix: string;
  }>;
  dependents: Array<{
    age: string;
  }>;
  loanApplicationId?: string;
  housingExpenses: {
    principalAndInterest: string;
    otherFinancing: string;
    hazardInsurance: string;
    propertyTax: string;
    mortgageInsurance: string;
    hoaDues: string;
    otherExpenses: string;
    pitiTotal: string;
  },
  createdAt?: Date;
  updatedAt?: Date;
  __v?: number;
  id?: string;
} 

export interface BorrowerEmployment {
  _id: string;
  employerName: string;
  position: string;
  startDate: Date;
  endDate: Date;
  years: string;
  months: string;
  professionStartDate: Date;
  professionEndDate: Date;
  professionYears: string;
  professionMonths: string;
  phone: string;
  fax: string;
  employerDbaName: string[];
  isCurrentlyEmployed: boolean;
  isEmployedByFamilyMember: boolean;
  isBusinessOwner: boolean;
  employmentStatus: string;
  monthlyIncome: Array<{
    incomeType: EmploymentIncomeType;
    monthlyAmount: string | number;
  }>;
  address: {
    street: string;
    unit: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
  employeeIdVoe?: string;
  employeeCodeVoe?: string;
  ownershipShare?: string | number;
}
export interface BorrowerEmploymentData {
  _id: string;
  borrowerId: string;
  loanApplicationId: string;
  personalInfo: PersonalInfo;
  employment: {
    _id: string;
    borrowerId: string;
    loanApplicationId: string;
    currentEmployments: [BorrowerEmployment],
    previousEmployments: [BorrowerEmployment],
    otherIncomes: [{
      _id: '',
      type: IncomeSourceType,
      monthlyAmount: string | number,
      description: string,
      isConsistent: boolean,
      isDocumented: boolean,
    }]
  }
}